import { Keyboard } from "lucide-react";

const DEFAULT_DESKTOP = [
  { keys: "Mouse", action: "Click, aim and use menus" },
  { keys: "Arrow keys / WASD", action: "Move (most games)" },
  { keys: "Space / Enter", action: "Jump, confirm or start" },
  { keys: "Esc", action: "Pause or open the game menu" },
];
const DEFAULT_TOUCH = [
  { keys: "Tap", action: "Click and use menus" },
  { keys: "Gamepad button", action: "Show on-screen D-pad and buttons" },
  { keys: "Fullscreen", action: "Turn sideways for a bigger picture" },
];

export function ControlsCard({ controls, touch }) {
  const custom = controls?.length > 0;
  const rows = custom ? controls : touch ? DEFAULT_TOUCH : DEFAULT_DESKTOP;
  return (
    <div data-testid="play-controls-card" className="w-full max-w-md text-left bg-zinc-950/80 border border-zinc-800 rounded-xl p-4">
      <div className="flex items-center gap-2 text-sm font-semibold mb-3">
        <Keyboard className="w-4 h-4 text-volt" /> {custom ? "Game controls" : "How to play"}
      </div>
      <ul className="space-y-1.5">
        {rows.map((c, i) => (
          <li key={i} data-testid={`play-control-${i}`} className="flex items-start gap-3 text-sm">
            <kbd className="shrink-0 min-w-[6.5rem] text-center font-mono text-xs bg-zinc-900 border border-zinc-700 rounded-md px-2 py-1 text-zinc-200">{c.keys}</kbd>
            <span className="text-zinc-400 pt-0.5">{c.action}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
